// extracted by mini-css-extract-plugin
export default {"iconSuccess":"IconStatus_iconSuccess__OD0pX","iconError":"IconStatus_iconError__Nf8dL","iconWarning":"IconStatus_iconWarning__Jk4e8","iconNotice":"IconStatus_iconNotice__ACxaJ"};